/**
 * @since 2023-08-07
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import TableSimulationStats from "components/Shared/TableSimulationStats";

const ItemTableSimStatsCollector = ({ itemData }) => {
  return <TableSimulationStats isLoading={false} data={itemData} />;
};

export default ItemTableSimStatsCollector;
